import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Input = styled.div`
  background: var(--background-primary);
  width: 100%;
  position: relative;
  &:focus-visible {
    outline: none;
  }
`;
const Label = styled.div`
  color: var(--text-secondary);
  ${Typography.body_md_medium}
`;

const EstimateBox = styled.div`
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${mobile_xl(css`
    padding: 8px 22px;
  `)}
`;

const InputLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  pointer-events: auto;
  input[type='time'] {
    color: var(--text-secondary) !important;
    ${Typography.body_lg_medium}
  }
  input[type='time'].selected {
    color: var(--text-primary) !important;
  }

  input[type='time']::-webkit-calendar-picker-indicator {
    opacity: 0;
    cursor: pointer;
  }
  input[type='time']::-webkit-inner-spin-button,
  input[type='time']::-webkit-clear-button {
    display: none;
  }
`;
const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  pointer-events: auto;
`;

export { EstimateBox, Input, Label, InputLabel, Buttons };
